module.exports = "https://img.zhijierongxing.com/saas/img/icon2.9afc6962.png";